import numeral from 'numeral';
import {getDefaultDescription} from 'lib/PropertyUtils';
import moment from 'moment/moment';

function currency(value) {
  return value ? numeral(value).format('$0,0') : '-';
}

function percentage(value) {
  return value ? numeral(value).format('0.0%') : '-';
}

function listingPrice(value) {
  return value || getDefaultDescription();
}

const dateFormatter = (date, format = 'D-MMM-YY') => date ? moment(date).format(format) : '-';

function indicativeSellingPrice({sellingPriceType, singlePrice, priceRange}) {
  switch (sellingPriceType) {
    case 'price-range':
      if (priceRange.min && priceRange.max) {
        return `Range between ${currency(priceRange.min)} \u0026 ${currency(priceRange.max)}`;
      }
      break;
    default: {
      if (singlePrice) {
        return `Single Price ${currency(singlePrice)}`;
      }
    }
  }
  return '-';
}

const Formatter = {
  currency,
  percentage,
  listingPrice,
  indicativeSellingPrice,
  dateFormatter,
};

export default Formatter;